// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"w3-z","colorTextValue":"x3-z","swatches":"y3-z","collapseLink":"z3-z","isCollapsed":"A3-z","dropdown":"B3-z","disabled":"C3-z"};